import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section">
          <h3>MIRAE</h3>
          <p className="footer-tagline">Future of Brilliance</p>
          <p className="footer-founder">Founder: @nishi_jain_</p>
          <p className="footer-location">Surat, India</p>
        </div>
        
        <div className="footer-section">
          <h4>Collections</h4>
          <Link to="/shop?category=gold">Gold</Link>
          <Link to="/shop?category=silver">Silver</Link>
          <Link to="/shop?category=diamond">Diamonds</Link>
        </div>
        
        <div className="footer-section">
          <h4>Contact</h4>
          <a href="https://instagram.com/mirae_jewel" target="_blank" rel="noopener noreferrer">
            Instagram
          </a>
          <a href="https://wa.me/919876543210" target="_blank" rel="noopener noreferrer">
            WhatsApp
          </a>
        </div>
      </div>
      <div className="footer-bottom">
        <p>© 2024 MIRAE Jewelry. All rights reserved. Crafted to be cherished.</p>
      </div>
    </footer>
  );
};

export default Footer;